import React, { useEffect, useRef } from "react";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import HomeSection from "./sections/HomeSection";
import ProofBarSection from "./sections/ProofBarSection";
import FeaturesSection from "./sections/FeaturesSection";
import LhdnStripSection from "./sections/LhdnStripSection";
import PatientAppSection from "./sections/PatientAppSection";
import UseCasesSection from "./sections/UseCasesSection";
import PricingSection from "./sections/PricingSection";
import AboutSection from "./sections/AboutSection";
import TestimonialsSection from "./sections/TestimonialsSection";
import ResourcesSection from "./sections/ResourcesSection";
import DemoSection from "./sections/DemoSection";
import CtaBannerSection from "./sections/CtaBannerSection";

function App() {
  const mainRef = useRef(null);

  useEffect(() => {
    const mainElement = mainRef.current;
    if (!mainElement) return;

    const sections = Array.from(mainElement.querySelectorAll("section"));
    if (!sections.length) return;

    sections.forEach((section, index) => {
      section.classList.add("reveal-section");
      section.style.setProperty("--reveal-delay", `${Math.min(index * 40, 220)}ms`);
    });

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      sections.forEach((section) => section.classList.add("is-visible"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.16,
        rootMargin: "0px 0px -10% 0px",
      }
    );

    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="app">
      <Navbar />
      <main ref={mainRef}>
        <HomeSection />
        <ProofBarSection />
        <FeaturesSection />
        <LhdnStripSection />
        <PatientAppSection />
        <UseCasesSection />
        <TestimonialsSection />
        <PricingSection />
        <AboutSection />
        <ResourcesSection />
        <DemoSection />
        <CtaBannerSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
